import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { KITTLogoStub } from '@components/KITTLogoStub';
import { EnvConfig } from '@config';
import { Button, cx, Flex, LoadingSpinner, Text } from '@endurancewarranty/ui';
import { useIsPopupWindow } from '@hooks/useIsPopupWindow';
import type { FC } from 'react';
type Props = {
  reason: string;
  /**
   * Server action to call when the user clicks the fallback "Sign in" button.
   */
  fallbackAction?: (formData: FormData) => void;
  /**
   * URL to return the user to after re-auth. Passed as a hidden form field.
   */
  fallbackCallbackUrl?: string;
  /**
   * Milliseconds before showing the fallback button.
   */
  fallbackDelayMs?: number;
};
const isQA = EnvConfig.appEnv === 'qa';
export const AuthLoading: FC<Props> = t0 => {
  const $ = _c(17);
  const {
    reason,
    fallbackAction,
    fallbackCallbackUrl,
    fallbackDelayMs
  } = t0;
  const [isNavbarShown, setIsNavbarShown] = useState(false);
  const [showFallback, setShowFallback] = useState(false);
  const isPopupWindow = useIsPopupWindow();
  let t1;
  let t2;
  if ($[0] !== isPopupWindow) {
    t1 = () => {
      if (!isPopupWindow) {
        setIsNavbarShown(true);
      }
    };
    t2 = [isPopupWindow, setIsNavbarShown];
    $[0] = isPopupWindow;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== fallbackAction || $[4] !== fallbackDelayMs) {
    t3 = () => {
      if (fallbackAction == null || fallbackDelayMs == null) {
        return;
      }
      const timer = setTimeout(() => setShowFallback(true), fallbackDelayMs);
      return () => clearTimeout(timer);
    };
    t4 = [fallbackAction, fallbackDelayMs];
    $[3] = fallbackAction;
    $[4] = fallbackDelayMs;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== isNavbarShown || $[8] !== reason) {
    t5 = isNavbarShown && <Flex className={cx("navbar-height w-full flex-shrink-0 px-6", {
      "bg-background-800": !isQA,
      "bg-yellow-500": isQA
    })} direction="row" items="center" justify="between"><KITTLogoStub /><Flex className="gap-4"><Text.Body size="md" color={0}>{reason}...</Text.Body><LoadingSpinner size={24} /></Flex></Flex>;
    $[7] = isNavbarShown;
    $[8] = reason;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fallbackAction || $[11] !== fallbackCallbackUrl || $[12] !== showFallback) {
    t6 = showFallback && fallbackAction != null && <Flex className="flex-1" direction="col" items="center" justify="center"><Text.Body size="sm" color={300}>Taking longer than expected?</Text.Body><form action={fallbackAction} className="mt-3">{fallbackCallbackUrl != null && <input type="hidden" name="callbackUrl" value={fallbackCallbackUrl} />}<Button type="submit" name="sign-in-fallback" variant="primary" size="md">Sign in manually</Button></form></Flex>;
    $[10] = fallbackAction;
    $[11] = fallbackCallbackUrl;
    $[12] = showFallback;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <Flex className="h-full w-full bg-background-50" items="center" justify="start" direction="col">{t5}{t6}</Flex>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};